import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Fan Icon Style 04 - HVAC (Material Symbol)
 * HVAC/ventilation style icon
 */
export const Style04_Hvac: React.FC<DeviceIconProps> = ({
  isOn = false,
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-blue-500' : 'text-slate-400';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      hvac
    </span>
  );
};

export default Style04_Hvac;
